import storage from "../../utils/storage";
import { AUTH_TOKEN_KEY, AUTH_USER_KEY } from "./AuthAdapter";

/**
 * Dev-only mock auth adapter.
 *
 * Gerçek backend bağlanana kadar yerel kimlik doğrulama sağlar. Mock olduğu
 * için **herhangi bir** email/şifre kombinasyonunu kabul eder; girilen email
 * varsa user objesine yazılır, yoksa default kullanıcı kullanılır. Üretim
 * kullanımı için `JwtAuthAdapter`'a geçiş yapın.
 *
 * Implements: IAuthAdapter (bkz. ./AuthAdapter.js).
 */

const DEFAULT_MOCK_USER = {
  id: "u-mock-1",
  email: "test@gmail.com",
  name: "Zehra Ecer",
  avatar: "/avatar.jpg",
};

const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

const MockAuthAdapter = {
  isAuthenticated() {
    return storage.theme.isAuthenticated();
  },

  getToken() {
    return storage.get(AUTH_TOKEN_KEY);
  },

  async getUser() {
    const raw = storage.get(AUTH_USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  async signIn(email /* , password */) {
    await sleep(150);
    const user = email
      ? { ...DEFAULT_MOCK_USER, email }
      : DEFAULT_MOCK_USER;
    storage.set(AUTH_TOKEN_KEY, "mock-jwt-token-" + Date.now());
    storage.set(AUTH_USER_KEY, JSON.stringify(user));
    storage.theme.setAuthenticated(true);
    return user;
  },

  async signOut() {
    storage.remove(AUTH_TOKEN_KEY);
    storage.remove(AUTH_USER_KEY);
    storage.theme.setAuthenticated(false);
  },
};

export default MockAuthAdapter;
